import { distinctUntilChanged, Observable } from 'rxjs';

export function distinctUntilKeysChanged<T>(keys: (keyof T)[]): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>): Observable<T> => source.pipe(
    distinctUntilChanged((prev: T, curr: T) => {
      return keys.every(key => prev[key] === curr[key]);
    })
  );
}
